function formatMoney(cents, format = "") {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
    formatString = format || window.themeVariables.settings.moneyFormat;
  function defaultTo(value2, defaultValue) {
    return value2 == null || value2 !== value2 ? defaultValue : value2;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ",");
    decimal = defaultTo(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100).toFixed(precision);
    let parts = number.split("."),
      dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        "$1" + thousands
      ),
      centsAmount = parts[1] ? decimal + parts[1] : "";
    return dollarsAmount + centsAmount;
  }
  let value = "";
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ");
      break;
    case "amount_no_decimals_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 0, "'");
      break;
    default:
      value = formatWithDelimiters(cents, 2);
      break;
  }
  if (formatString.indexOf("with_comma_separator") !== -1) {
    return formatString.replace(placeholderRegex, value);
  } else {
    return formatString.replace(placeholderRegex, value);
  }
}

Shopify.formatMoney = formatMoney;

const modalOverlay = document.querySelector(".modal-overlay");

class MultiblockSwiper extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.slidesPerViewDesktop = this.getAttribute(
      "data-slides-per-view-desktop"
    );
    this.slidesPerViewMobile = this.getAttribute("data-slides-per-view-mobile");
    this.init();
  }

  init() {
    this.swiper = new Swiper(this, {
      slidesPerView: this.slidesPerViewMobile,
      spaceBetween: 20,
      loop: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        768: {
          slidesPerView: this.slidesPerViewDesktop,
          spaceBetween: 28,
        },
      },
    });
  }
}

if (!window.customElements.get("multiblock-swiper")) {
  window.customElements.define("multiblock-swiper", MultiblockSwiper);
}

class NumberTicker extends HTMLElement {
  connectedCallback() {
    const reduceMotion = window.matchMedia(
      "(prefers-reduced-motion: no-preference)"
    ).matches;

    if (reduceMotion) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.processTicker();
              observer.unobserve(this);
            }
          });
        },
        {
          threshold: 0.1,
        }
      );

      observer.observe(this);
    } else {
      const valueTo = parseInt(this.getAttribute("data-to-value")) || 0;
      const targetElement = this.querySelector("[data-counter-number]");
      targetElement.innerText = valueTo;
    }
  }

  processTicker() {
    const duration = parseInt(this.getAttribute("data-duration")) || 2000;
    const valueTo = parseInt(this.getAttribute("data-to-value")) || 0;
    const valueFrom = 0;

    let number = valueFrom;
    const incrementStep = Math.ceil((valueTo - valueFrom) / 100);
    const durationStep = duration / 100;

    const targetElement = this.querySelector("[data-counter-number]");

    const interval = setInterval(() => {
      targetElement.innerText = number;

      if (number >= valueTo) {
        clearInterval(interval);
        targetElement.innerText = valueTo;
      }

      number += incrementStep;
    }, durationStep);
  }
}

if (!window.customElements.get("number-ticker")) {
  window.customElements.define("number-ticker", NumberTicker);
}

class QuickAdd extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector("[data-quick-add-button]");
    this.modal = this.querySelector("quick-add-modal");
    this.bindEvents();
  }

  bindEvents() {
    if (!this.button || !this.modal) return;

    this.button.addEventListener("click", (event) => {
      event.preventDefault();
      this.open();
    });

    this.modal.addEventListener("click", (event) => {
      if (event.target === this.modal) {
        this.close();
      }
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && this.modal.classList.contains("active")) {
        this.close();
      }
    });

    const closeButton = this.modal.querySelector("[data-quick-add-close]");
    if (closeButton) {
      closeButton.addEventListener("click", this.close.bind(this));
    }
  }

  open() {
    this.modal.open();
  }

  close() {
    this.modal.close();
  }
}

if (!window.customElements.get("quick-add")) {
  window.customElements.define("quick-add", QuickAdd);
}

class QuickAddModal extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.bindEvents();
  }

  bindEvents() {
    modalOverlay.addEventListener("click", this.close.bind(this));
    this.addEventListener(
      "variant:change",
      this.handleVariantChange.bind(this)
    );
  }

  open() {
    this.classList.add("active");
  }

  close() {
    this.classList.remove("active");
  }

  handleVariantChange(event) {
    const variant = event.detail.variant;

    const images = this.querySelectorAll(".quick-add-modal__image");
    const matchingImage = Array.from(images).find(
      (image) => parseInt(image.dataset.variantId) === variant.id
    );

    if (matchingImage) {
      images.forEach((image) =>
        image.classList.toggle("hidden", image !== matchingImage)
      );
    }
  }
}

if (!window.customElements.get("quick-add-modal")) {
  window.customElements.define("quick-add-modal", QuickAddModal);
}

class ProductForm extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.masterSelect = this.querySelector("[name='id']");
    this.form = this.querySelector("form");
    this.bindEvents();
  }

  bindEvents() {
    this.addEventListener(
      "variant:change",
      this.handleVariantChange.bind(this)
    );
    this.form.addEventListener("submit", this.handleSubmit.bind(this));
  }

  handleVariantChange(event) {
    const variant = event.detail.variant;
    this.masterSelect.value = variant.id;
  }

  handleSubmit(event) {
    event.preventDefault();

    const formData = new FormData(this.form);

    formData.set("sections", ["cart-drawer"]);

    this.dispatchEvent(
      new CustomEvent("cart-loading", {
        bubbles: true,
      })
    );
    fetch("/cart/add.js", {
      method: "POST",
      body: formData,
      headers: {
        "X-Requested-With": "XMLHttpRequest",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        const cartDrawer = document.querySelector("cart-drawer");
        cartDrawer.reloadCart(data.sections["cart-drawer"], true);
      });
  }
}

if (!window.customElements.get("product-form")) {
  window.customElements.define("product-form", ProductForm);
}

class VariantPicker extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.variants = JSON.parse(
      this.querySelector("[data-variants]").textContent
    ).variants;
    this.currentVariant = null;
    this.optionInputs = this.querySelectorAll("input");
    this.bindEvents();
  }

  bindEvents() {
    this.listenToChange();
  }

  listenToChange() {
    this.optionInputs.forEach((input) => {
      input.addEventListener("change", this.updateCurrentVariant.bind(this));
    });
  }
  getSelectedValues() {
    return Array.from(this.querySelectorAll("input:checked")).reduce(
      (acc, input) => {
        acc[input.name] = input.value;
        return acc;
      },
      {}
    );
  }

  updateCurrentVariant() {
    const selectedValues = this.getSelectedValues();

    this.currentVariant =
      this.variants.find((variant) => {
        return Object.entries(selectedValues).every(([name, value]) => {
          return variant[name] === value;
        });
      }) || null;

    if (this.currentVariant) {
      this.dispatchEvent(
        new CustomEvent("variant:change", {
          detail: {
            variant: this.currentVariant,
          },
          bubbles: true,
        })
      );
    }
  }
}

if (!window.customElements.get("variant-picker")) {
  window.customElements.define("variant-picker", VariantPicker);
}

class HeaderInner extends HTMLElement {
  constructor() {
    super();
    this.closeTimeout = null;
  }

  connectedCallback() {
    this.bindEvents();
  }

  bindEvents() {
    this.header = this.closest("header");
    this.setupMegaMenuTriggers();
    this.setupScrollListener();
  }

  setupScrollListener() {
    let lastScrollY = window.scrollY;

    window.addEventListener("scroll", () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY > 100) {
        if (currentScrollY > lastScrollY) {
          this.header.classList.add("scrolling-down");
        } else if (currentScrollY < lastScrollY) {
          this.header.classList.remove("scrolling-down");
        }
      } else {
        this.header.classList.remove("scrolling-down");
      }

      lastScrollY = currentScrollY;
    });
  }

  setupMegaMenuTriggers() {
    this.megaMenus = Array.from(this.querySelectorAll("mega-menu"));
    this.addEventListener("mouseleave", this.closeAllMegaMenus.bind(this));
    this.addEventListener("mega-menu:toggle", (e) =>
      this.handleMegaMenuToggle(e)
    );
  }

  handleMegaMenuToggle(event) {
    const active = event.detail.active;
    const title = event.detail.title;
    if (active) {
      this.megaMenus
        .filter((menu) => menu.dataset.megaMenu !== title)
        .forEach((menu) => menu.classList.remove("active"));
    }
  }

  closeAllMegaMenus() {
    this.megaMenus.forEach((menu) => menu.classList.remove("active"));
  }
}

if (!window.customElements.get("header-inner")) {
  window.customElements.define("header-inner", HeaderInner);
}

class MegaMenuWrapper extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.bindEvents();
  }
  bindEvents() {
    this.title = this.dataset.title;
    this.megaMenu = this.querySelector("mega-menu");
    this.debounceTimeout = null;
    this.addEventListener("mouseenter", () =>
      this.debouncedToggleMegaMenu(true)
    );
    this.addEventListener("mouseleave", () =>
      this.debouncedToggleMegaMenu(false)
    );
  }

  debouncedToggleMegaMenu(active) {
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout);
    }

    this.debounceTimeout = setTimeout(
      () => {
        this.toggleMegaMenu(active);
      },
      active ? 0 : 300
    );
  }

  toggleMegaMenu(active) {
    this.megaMenu.classList.toggle("active", active);
    this.dispatchEvent(
      new CustomEvent("mega-menu:toggle", {
        detail: {
          active,
          title: this.title,
        },
        bubbles: true,
      })
    );
  }
}

if (!window.customElements.get("mega-menu-wrapper")) {
  window.customElements.define("mega-menu-wrapper", MegaMenuWrapper);
}

class MegaMenu extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.bindEvents();
  }

  bindEvents() {
    this.innerMenus = Array.from(this.querySelectorAll("[data-inner-menu]"));
    this.innerTriggers = Array.from(
      this.querySelectorAll("[data-inner-trigger]")
    );
    this.innerTriggers.forEach((trigger) =>
      trigger.addEventListener("mouseenter", () =>
        this.toggleInnerMenu(trigger, true)
      )
    );
  }

  toggleInnerMenu(trigger, open = true) {
    this.closeAllInnerMenus();
    const innerMenuTitle = trigger.dataset.innerTrigger;
    const innerMenu = this.querySelector(
      `[data-inner-menu="${innerMenuTitle}"]`
    );
    trigger.classList.toggle("active", open);
    if (!innerMenu) return;
    innerMenu.classList.toggle("active", open);
  }

  closeAllInnerMenus() {
    this.innerMenus.forEach((menu) => menu.classList.remove("active"));
    this.innerTriggers.forEach((trigger) => trigger.classList.remove("active"));
  }
}

if (!window.customElements.get("mega-menu")) {
  window.customElements.define("mega-menu", MegaMenu);
}

class MenuDrawer extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.openButtons = document.querySelectorAll("[data-menu-drawer-open]");
    this.openButtons.forEach((button) =>
      button.addEventListener("click", () => this.toggleOpen(true))
    );
    this.closeButtons = document.querySelectorAll("[data-menu-drawer-close]");
    this.closeButtons.forEach((button) =>
      button.addEventListener("click", () => this.close())
    );
    this.panels = Array.from(this.querySelectorAll("[data-panel]"));
    this.panelTriggers = Array.from(
      this.querySelectorAll("[data-panel-trigger]")
    );
    this.panelTriggers.forEach((trigger) => {
      trigger.addEventListener("click", () => {
        const panel = this.panels.find(
          (panel) => panel.dataset.panel === trigger.dataset.panelTrigger
        );
        panel.classList.add("active");
      });
    });
    this.closePanels = Array.from(this.querySelectorAll("[data-close-panels]"));
    this.closePanels.forEach((panel) =>
      panel.addEventListener("click", () => this.closeAllPanels())
    );
    this.backButton = this.querySelector("[data-menu-drawer-back]");
    this.backButton.addEventListener("click", () => this.back());
  }

  close() {
    this.classList.remove("active");
    this.closeAllPanels();
  }

  back() {
    this.panels.forEach((panel) => panel.classList.remove("active"));
  }

  closeAllPanels() {
    this.panels.forEach((panel) => panel.classList.remove("active"));
  }

  toggleOpen(active = true) {
    this.classList.toggle("active", active);
  }
}

if (!window.customElements.get("menu-drawer")) {
  window.customElements.define("menu-drawer", MenuDrawer);
}

class ProductPage extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.variantInputs = this.querySelectorAll("[name='id']");
    this.addEventListener("variant:change", (e) => {
      this.variantInputs.forEach(
        (input) => (input.value = e.detail.variant.id)
      );
    });
  }
}

if (!window.customElements.get("product-page")) {
  window.customElements.define("product-page", ProductPage);
}

class ProductGallery extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.initMainSwiper();
    this.initThumbnails();
  }

  initMainSwiper() {
    const currentNumber = this.querySelector("[data-swiper-number-current]");
    const totalNumber = this.querySelector("[data-swiper-number-total]");
    this.swiper = new Swiper(this.querySelector(".product-gallery__swiper"), {
      slidesPerView: 1,
      spaceBetween: 10,
      navigation: {
        nextEl: this.querySelector(".next"),
        prevEl: this.querySelector(".prev"),
      },
      pagination: {
        el: this.querySelector(".swiper-pagination"),
        clickable: true,
      },
    });

    this.swiper.on("slideChange", () => {
      if (currentNumber) currentNumber.textContent = this.swiper.realIndex + 1;
    });
  }

  initThumbnails() {
    this.thumbnails = this.querySelectorAll("[data-thumbnail]");
    this.thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener("click", () =>
        this.swiper.slideTo(thumbnail.dataset.index)
      );
    });

    this.swiper.on("slideChange", () => {
      this.thumbnails.forEach((thumbnail) => {
        thumbnail.classList.remove("active");
      });
      this.thumbnails[this.swiper.activeIndex].classList.add("active");
    });
  }
}

if (!window.customElements.get("product-gallery")) {
  window.customElements.define("product-gallery", ProductGallery);
}

class ProductInfo extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.variantInput = this.querySelector("[name='id']");
    this.priceElements = this.querySelectorAll("[data-product-price]");
    this.atcButton = this.querySelector("[data-atc-button]");
    this.comparePriceElements = this.querySelectorAll(
      "[data-product-compare-price]"
    );
    this.sellingPlanSelector = this.querySelector("selling-plan-selector");
    this.bindEvents();
  }

  bindEvents() {
    this.addEventListener(
      "variant:change",
      this.handleVariantChange.bind(this)
    );
    if (this.sellingPlanSelector) {
      this.sellingPlanSelector.addEventListener(
        "selling-plan:change",
        this.handleSellingPlanChange.bind(this)
      );
    }
    this.accordions = this.querySelectorAll("details");
    this.setupAccordions();
  }

  setupAccordions() {
    this.accordions.forEach((accordion) => {
      accordion.addEventListener("click", (e) => {
        const clickedAccordion = e.currentTarget;

        this.accordions.forEach((accordion) => {
          if (
            accordion !== clickedAccordion &&
            accordion.hasAttribute("open")
          ) {
            accordion.removeAttribute("open");
          }
        });
      });
    });
  }

  handleVariantChange(event) {
    const variant = event.detail.variant;
    this.variantInput.value = variant.id;
    updateAllElements(this.priceElements, Shopify.formatMoney(variant.price));
    updateAllElements(this.comparePriceElements, "");
    if (variant.compare_at_price > variant.price) {
      updateAllElements(
        this.comparePriceElements,
        Shopify.formatMoney(variant.compare_at_price)
      );
    }

    this.updateAtcButton(variant);

    const url = new URL(window.location.href);
    url.searchParams.set("variant", variant.id);
    window.history.replaceState({}, "", url);
  }

  updateAtcButton(variant) {
    if (variant.available) {
      this.atcButton.removeAttribute("disabled");
      this.atcButton.classList.remove("opacity-50");
      this.atcButton.textContent = "Add to Cart";
    } else {
      this.atcButton.setAttribute("disabled", "");
      this.atcButton.classList.add("opacity-50");
      this.atcButton.textContent = "Sold Out";
    }
  }

  handleSellingPlanChange(event) {
    const price = event.detail.price;
    const comparePrice = event.detail.comparePrice;
    this.priceElements.forEach((priceElement) => {
      priceElement.textContent = Shopify.formatMoney(price);
    });
    updateAllElements(this.comparePriceElements, "");
    if (comparePrice) {
      updateAllElements(
        this.comparePriceElements,
        Shopify.formatMoney(comparePrice)
      );
    }
  }
}

if (!window.customElements.get("product-info")) {
  window.customElements.define("product-info", ProductInfo);
}

class SellingPlanSelector extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.addEventListener(
      "change",
      this.handleSellingPlanPillChange.bind(this)
    );
  }

  handleSellingPlanPillChange(event) {
    const selectedSellingPlanPill = event.target;
    const selectedSellingPlanId = selectedSellingPlanPill.value;
    this.dispatchEvent(
      new CustomEvent("selling-plan:change", {
        detail: {
          sellingPlanId: selectedSellingPlanId,
          price: selectedSellingPlanPill.dataset.price,
          comparePrice: selectedSellingPlanPill.dataset.comparePrice,
        },
      })
    );
  }
}

if (!window.customElements.get("selling-plan-selector")) {
  window.customElements.define("selling-plan-selector", SellingPlanSelector);
}

function updateAllElements(elements, value) {
  elements.forEach((element) => {
    element.textContent = value;
  });
}

class EchoDropdown extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.trigger = this.querySelector("button");
    this.content = this.querySelector("[data-dropdown-content]");
    this.mobilePopup = this.querySelector("[data-mobile-popup]");
    this.items = this.querySelectorAll("[data-dropdown-item]");
    this.bindEvents();
  }

  bindEvents() {
    this.trigger.addEventListener("click", this.toggleOpen.bind(this));
    document.addEventListener("click", this.handleClickOutside.bind(this));
    this.items.forEach((item) => {
      item.addEventListener("change", this.handleItemChange.bind(this));
    });
  }

  handleClickOutside(event) {
    if (!this.contains(event.target)) {
      this.content.classList.remove("active");
      this.mobilePopup?.classList.remove("active");
    }
  }

  toggleOpen(event, open = true) {
    event.stopPropagation();
    this.content.classList.toggle("active", open);
    this.mobilePopup?.classList.toggle("active", open);
  }

  handleItemChange(event) {
    const item = event.target;
    const value = item.value;
    this.trigger.textContent = value;
    this.toggleOpen(event, false);
  }
}

if (!window.customElements.get("echo-dropdown")) {
  window.customElements.define("echo-dropdown", EchoDropdown);
}
class MobilePopup extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    this.overlay = this.querySelector("[data-mobile-popup-overlay]");
    this.overlay.addEventListener("click", () => {
      this.close();
    });
  }

  close() {
    this.classList.remove("active");
  }

  open() {
    this.classList.add("active");
  }
}

if (!window.customElements.get("mobile-popup")) {
  window.customElements.define("mobile-popup", MobilePopup);
}

class ScrollSection extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
    document.addEventListener("resize", this.init.bind(this));
  }

  init() {
    this.bindEvents();
    this.calculateHeight();
  }

  bindEvents() {
    this.scrollBlocks = Array.from(
      this.querySelectorAll("[data-scroll-block]")
    );
    document.addEventListener("scroll", this.handleScroll.bind(this));
  }

  handleScroll() {
    const scrollPosition = window.scrollY;
    const sectionTop = this.offsetTop;
    const sectionHeight = this.offsetHeight;
    const scrollProgress = (scrollPosition - sectionTop) / sectionHeight;

    const isMobile = window.innerWidth <= 767;
    const threshold = isMobile ? -0.05 : 0;
    this.classList.toggle("active", scrollProgress > threshold);

    //handle blocks
    this.scrollBlocks.forEach((block, index) => {
      const blockProgress = index / this.scrollBlocks.length;
      const blockStart = blockProgress - 0.2;
      const blockEnd = blockProgress + 0.2;

      let opacity;
      if (scrollProgress < blockStart) {
        opacity = 0;
      } else if (scrollProgress > blockEnd) {
        opacity = 0;
      } else if (scrollProgress < blockEnd && index == 0) {
        opacity = 1;
      } else {
        opacity = 1 - Math.abs((scrollProgress - blockProgress) / 0.2);
      }

      opacity = Math.max(0, Math.min(1, opacity));
      block.style.opacity = opacity;

      if (opacity > 0.5) {
        block.classList.add("active");
      } else {
        block.classList.remove("active");
      }
    });
  }

  calculateHeight() {
    const height = this.scrollBlocks.length * window.innerHeight;
    this.style.height = `${height}px`;
    this.classList.add("is-initialised");
  }
}

if (!window.customElements.get("scroll-section")) {
  window.customElements.define("scroll-section", ScrollSection);
}

class InfoTabs extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.bindEvents();
  }

  bindEvents() {
    this.tabs = this.querySelectorAll("[data-tab-id]");
    this.tabTriggers = this.querySelectorAll("[data-tab-trigger]");
    this.tabTriggers.forEach((tabTrigger) => {
      tabTrigger.addEventListener("click", () => {
        this.toggleTab(tabTrigger.dataset.tabTrigger);
      });
    });
  }

  toggleTab(tabTriggerValue) {
    this.tabTriggers.forEach((c) =>
      c.classList.toggle("active", c.dataset.tabTrigger === tabTriggerValue)
    );
    this.tabs.forEach((tab) =>
      tab.classList.toggle("active", tab.dataset.tabId === tabTriggerValue)
    );
  }
}

if (!window.customElements.get("info-tabs")) {
  window.customElements.define("info-tabs", InfoTabs);
}

class InfoTabSwiper extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.slidesPerViewDesktop = this.getAttribute(
      "data-slides-per-view-desktop"
    );
    this.slidesPerViewMobile = this.getAttribute("data-slides-per-view-mobile");
    this.init();
  }

  init() {
    this.swiper = new Swiper(this, {
      slidesPerView: this.slidesPerViewMobile,
      spaceBetween: 20,
      loop: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        768: {
          slidesPerView: this.slidesPerViewDesktop,
          spaceBetween: 28,
        },
      },
    });
  }
}

if (!window.customElements.get("info-tab-swiper")) {
  window.customElements.define("info-tab-swiper", InfoTabSwiper);
}

class ExpandableMultiblock extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    this.addEventListener("click", this.toggleOpen.bind(this));

    if (window.innerWidth > 768) {
      this.addEventListener("mouseenter", this.setOpen.bind(this, true));
      this.addEventListener("mouseleave", this.setOpen.bind(this, false));
    }
  }

  toggleOpen() {
    this.classList.toggle("active");
  }

  setOpen(open = true) {
    this.classList.toggle("active", open);
  }
}

if (!window.customElements.get("expandable-multiblock")) {
  window.customElements.define("expandable-multiblock", ExpandableMultiblock);
}

class YoutubeBlogs extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    const loadMoreButton = this.querySelector("[data-load-more]");
    if (loadMoreButton) {
      loadMoreButton.addEventListener("click", this.loadMore.bind(this));
    }
  }

  loadMore() {
    const hiddenItems = this.querySelectorAll(".hidden.md\\:flex");
    const loadMoreButton = this.querySelector("[data-load-more]");

    for (let i = 0; i < 3 && i < hiddenItems.length; i++) {
      hiddenItems[i].classList.remove("hidden");
    }

    if (hiddenItems.length <= 3) {
      loadMoreButton.style.display = "none";
    }
  }
}

if (!window.customElements.get("youtube-blogs")) {
  window.customElements.define("youtube-blogs", YoutubeBlogs);
}

class UpcomingEvents extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.loadMoreButton = this.querySelector("[data-load-more]");
    this.loadMoreText = this.querySelector("[data-load-more-text]");
    this.loadLessText = this.querySelector("[data-load-less-text]");
    this.expanded = false;
    this.lazyEvents = this.querySelectorAll(".lazy-event");
    this.loadMoreButton.addEventListener("click", this.toggleEvents.bind(this));
  }

  toggleEvents() {
    this.expanded = !this.expanded;
    this.lazyEvents.forEach((event) =>
      event.classList.toggle("hidden", !this.expanded)
    );

    this.loadMoreText.classList.toggle("hidden", this.expanded);
    this.loadLessText.classList.toggle("hidden", !this.expanded);
  }
}

if (!window.customElements.get("upcoming-events")) {
  window.customElements.define("upcoming-events", UpcomingEvents);
}

class BlogSection1 extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    this.swiper = new Swiper(this, {
      slidesPerView: 1,
      spaceBetween: 20,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
        },
      },
    });
  }
}

if (!window.customElements.get("blog-section-1")) {
  window.customElements.define("blog-section-1", BlogSection1);
}

class OurMissionSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    this.swiper = new Swiper(this, {
      slidesPerView: 1.2,
      spaceBetween: 10,
      loop: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        768: {
          slidesPerView: 3.2,
        },
      },
    });
  }
}

if (!window.customElements.get("our-mission-slider")) {
  window.customElements.define("our-mission-slider", OurMissionSlider);
}

class InTheNews extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    this.swiper = new Swiper(this, {
      spaceBetween: 36,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      grid: {
        rows: 2,
        columns: 1,
        fill: "row",
      },
      slidesPerView: 1,
      breakpoints: {
        768: {
          grid: {
            rows: 2,
            columns: 3,
            fill: "row",
          },
          slidesPerView: 3,
        },
      },
    });
  }
}

if (!window.customElements.get("in-the-news")) {
  window.customElements.define("in-the-news", InTheNews);
}

class OverviewSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.initSwiper();
  }

  initSwiper() {
    this.swiper = new Swiper(this, {
      slidesPerView: 1,
    });
  }
}

if (!window.customElements.get("overview-slider")) {
  window.customElements.define("overview-slider", OverviewSlider);
}

class TechSpecsHero extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    this.blocks = Array.from(this.querySelectorAll("[data-tech-spec-block]"));
    this.headings = Array.from(
      this.querySelectorAll("[data-tech-spec-heading]")
    );

    document.addEventListener("scroll", this.handleScroll.bind(this));
  }

  handleScroll() {
    let activeHeading = this.blocks[0].dataset.techSpecBlock;
    this.blocks.forEach((block) => {
      const blockTop = block.offsetTop;
      const scrollPosition = window.scrollY;

      if (scrollPosition >= blockTop - 100) {
        activeHeading = block.dataset.techSpecBlock;
      }
    });

    this.headings.forEach((heading) =>
      heading.classList.toggle(
        "active",
        heading.dataset.techSpecHeading === activeHeading
      )
    );
  }
}

if (!window.customElements.get("tech-specs-hero")) {
  window.customElements.define("tech-specs-hero", TechSpecsHero);
}

class StickyAtc extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    document.addEventListener("scroll", this.handleScroll.bind(this));
  }

  handleScroll() {
    const scrollPosition = window.scrollY;

    this.classList.toggle("active", scrollPosition > 500);
  }
}

if (!window.customElements.get("sticky-atc")) {
  window.customElements.define("sticky-atc", StickyAtc);
}

class TakeChargeSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.swiper = new Swiper(this, {
      slidesPerView: "auto",
      spaceBetween: 10,
      loop: true,
      slidesOffsetBefore: -120,
      navigation: {
        nextEl: this.parentElement.querySelector(".next"),
        prevEl: this.parentElement.querySelector(".prev"),
      },
      breakpoints: {
        1024: {
          slidesOffsetBefore: 0,
          navigation: {
            nextEl: this.parentElement.querySelector(".prev"),
            prevEl: this.parentElement.querySelector(".next"),
          },
        },
      },
    });
  }
}

if (!window.customElements.get("take-charge-slider")) {
  window.customElements.define("take-charge-slider", TakeChargeSlider);
}

class PremiumFeaturesSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.swiper = new Swiper(this, {
      slidesPerView: 1.2,
      spaceBetween: 20,
      slidesOffsetBefore: 20,
      navigation: {
        nextEl: this.parentElement.querySelector(".next"),
        prevEl: this.parentElement.querySelector(".prev"),
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
          slidesOffsetBefore: 0,
          navigation: {
            nextEl: this.parentElement.querySelector(".prev"),
            prevEl: this.parentElement.querySelector(".next"),
          },
        },
      },
    });
  }
}

if (!window.customElements.get("premium-features-slider")) {
  window.customElements.define(
    "premium-features-slider",
    PremiumFeaturesSlider
  );
}

class SupplementReviews extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.initSwiper();
  }

  initSwiper() {
    this.swiper = new Swiper(this.querySelector(".swiper"), {
      slidesPerView: 1,
      spaceBetween: 32,
      loop: true,
      navigation: {
        nextEl: this.querySelector(".next"),
        prevEl: this.querySelector(".prev"),
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
      },
    });
  }
}

if (!window.customElements.get("supplement-reviews")) {
  window.customElements.define("supplement-reviews", SupplementReviews);
}

class WhwfColumns extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.numberOfColumns = this.getAttribute("data-columns");
    this.initSwiper();
  }

  initSwiper() {
    this.swiper = new Swiper(this, {
      slidesPerView: 1,
      spaceBetween: 10,
      navigation: {
        nextEl: this.parentElement.querySelector(".next"),
        prevEl: this.parentElement.querySelector(".prev"),
      },
      breakpoints: {
        1024: {
          slidesPerView: this.numberOfColumns,
        },
      },
    });
  }
}

if (!window.customElements.get("whwf-columns")) {
  window.customElements.define("whwf-columns", WhwfColumns);
}

class ReadMore extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.preview = this.querySelector("[data-preview]");
    this.fullText = this.querySelector("[data-full-text]");
    this.toggleButton = this.querySelector("[data-toggle-button]");
    this.readMoreText = this.toggleButton.dataset.readMore;
    this.readLessText = this.toggleButton.dataset.readLess;
    this.isExpanded = false;

    // Initially hide the full text and show the preview
    if (this.fullText) this.fullText.style.display = "none";
    if (this.preview) this.preview.style.display = "inline"; // Or 'block'/'inline-block' depending on context
    this.toggleButton.textContent = this.readMoreText;

    this.toggleButton.addEventListener("click", this.toggle.bind(this));
  }

  toggle() {
    this.isExpanded = !this.isExpanded;

    if (this.isExpanded) {
      if (this.preview) this.preview.style.display = "none";
      if (this.fullText) this.fullText.style.display = "inline"; // Or 'block'/'inline-block'
      this.toggleButton.textContent = this.readLessText;
    } else {
      if (this.preview) this.preview.style.display = "inline"; // Or 'block'/'inline-block'
      if (this.fullText) this.fullText.style.display = "none";
      this.toggleButton.textContent = this.readMoreText;
    }
  }
}

if (!window.customElements.get("read-more")) {
  window.customElements.define("read-more", ReadMore);
}

class LogoCarousel extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.initSwiper();
  }

  initSwiper() {
    this.swiper = new Swiper(this.querySelector(".swiper"), {
      slidesPerView: 2,
      spaceBetween: 10,
      loop: true,
      breakpoints: {
        768: {
          slidesPerView: 6,
        },
      },
      navigation: {
        nextEl: this.querySelector(".next"),
        prevEl: this.querySelector(".prev"),
      },
    });
  }
}

if (!window.customElements.get("logo-carousel")) {
  window.customElements.define("logo-carousel", LogoCarousel);
}

class IconsAndText extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.desktopSlides = this.getAttribute("data-desktop-slides");
    this.initSwiper();
  }

  initSwiper() {
    this.swiper = new Swiper(this, {
      slidesPerView: "auto",
      spaceBetween: 40,
      loop: true,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      breakpoints: {
        768: {
          slidesPerView: this.desktopSlides,
          autoplay: false,
          spaceBetween: 10,
        },
      },
    });
  }
}

if (!window.customElements.get("icons-and-text")) {
  window.customElements.define("icons-and-text", IconsAndText);
}

class AtcBlockButton extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    const productPage = document.querySelector("product-page");
    if (productPage) {
      this.addEventListener("click", () => {
        productPage.querySelector("button[type='submit']").click();
      });
    }
  }
}

if (!window.customElements.get("atc-block-button")) {
  window.customElements.define("atc-block-button", AtcBlockButton);
}

class CertificationCarousel extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.initSwiper();
  }

  initSwiper() {
    this.swiper = new Swiper(this, {
      slidesPerView: "auto",
      spaceBetween: 20,
      slidesOffsetBefore: 16,
      slidesOffsetAfter: 16,
    });
  }
}

if (!window.customElements.get("certification-carousel")) {
  window.customElements.define("certification-carousel", CertificationCarousel);
}

class FeelBetterSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initSwiper();
  }

  initSwiper() {
    this.swiper = new Swiper(this.querySelector(".swiper"), {
      slidesPerView: "auto",
      spaceBetween: 20,
      loop: true,
      slidesOffsetAfter: 20,
      navigation: {
        nextEl: this.querySelector(".next"),
        prevEl: this.querySelector(".prev"),
      },
    });
  }
}

if (!window.customElements.get("feel-better-slider")) {
  window.customElements.define("feel-better-slider", FeelBetterSlider);
}

class FlaskLogoCarousel extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.autoplayDelay = this.getAttribute("data-autoplay-delay");
    this.initSwiper();
  }

  initSwiper() {
    this.swiper = new Swiper(this.querySelector(".swiper"), {
      slidesPerView: "auto",
      spaceBetween: 40,
      loop: true,
      slidesOffsetBefore: 20,
      slidesOffsetAfter: 20,
      autoplay: {
        delay: this.autoplayDelay * 1000,
        disableOnInteraction: false,
      },
      breakpoints: {
        768: {
          spaceBetween: 0,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0,
        },
      },
    });
  }
}

if (!window.customElements.get("flask-logo-carousel")) {
  window.customElements.define("flask-logo-carousel", FlaskLogoCarousel);
}

class VideoCarousel extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initSwiper();
  }

  initSwiper() {
    new Swiper(this, {
      slidesPerView: 1.5,
      centeredSlides: true,
      spaceBetween: 20,
      loop: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        768: {
          loop: false,
          slidesPerView: this.getAttribute("data-slides"),
          centeredSlides: false,
        },
      },
    });
  }
}

if (!window.customElements.get("video-carousel")) {
  window.customElements.define("video-carousel", VideoCarousel);
}

class WhyHydrogenSwiper extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initSwiper();
  }

  initSwiper() {
    this.swiper = new Swiper(this, {
      slidesPerView: 1,
      spaceBetween: 10,
      loop: true,
      pagination: {
        el: this.querySelector(".swiper-pagination"),
        clickable: true,
      },
    });
  }
}

if (!window.customElements.get("why-hydrogen-swiper")) {
  window.customElements.define("why-hydrogen-swiper", WhyHydrogenSwiper);
}
class WhyHydrogenAccordions extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.accordions = this.querySelectorAll("details");
    this.bindEvents();
  }

  bindEvents() {
    this.accordions.forEach((accordion) => {
      accordion.addEventListener("click", (e) => {
        const clickedAccordion = e.currentTarget;

        this.accordions.forEach((accordion) => {
          if (
            accordion !== clickedAccordion &&
            accordion.hasAttribute("open")
          ) {
            accordion.removeAttribute("open");
          }
        });
      });
    });
  }
}

if (!window.customElements.get("why-hydrogen-accordions")) {
  window.customElements.define(
    "why-hydrogen-accordions",
    WhyHydrogenAccordions
  );
}

class FlaskBuzzSwiper extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initSwiper();
  }

  initSwiper() {
    this.swiper = new Swiper(this, {
      slidesPerView: "auto",
      loop: true,
      centeredSlides: true,
      navigation: {
        nextEl: this.querySelector(".next"),
        prevEl: this.querySelector(".prev"),
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
        },
      },
    });
  }
}

if (!window.customElements.get("flask-buzz-swiper")) {
  window.customElements.define("flask-buzz-swiper", FlaskBuzzSwiper);
}

class HoverVideo extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.video = this.querySelector("video");
    this.bindEvents();
  }

  bindEvents() {
    this.addEventListener("mouseenter", this.playVideo.bind(this));
    this.addEventListener("mouseleave", this.pauseVideo.bind(this));
  }

  playVideo() {
    this.video.play();
  }

  pauseVideo() {
    this.video.pause();
  }
}

if (!window.customElements.get("hover-video")) {
  window.customElements.define("hover-video", HoverVideo);
}

class ClickVideo extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.video = this.querySelector("video");
    this.playButton = document.createElement("div");
    this.playButton.className = "click-video-play-button";
    this.playButton.innerHTML = `
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8 5.14V19.14L19 12.14L8 5.14Z" fill="white"/>
        </svg>
      `;
    this.appendChild(this.playButton);
    this.bindEvents();
  }

  bindEvents() {
    this.addEventListener("click", this.toggleVideo.bind(this));
  }

  toggleVideo() {
    if (this.video.paused) {
      document.querySelectorAll("video").forEach((video) => video.pause());
      document
        .querySelectorAll("click-video")
        .forEach((video) => video.classList.add("paused"));
      this.video.play();
    } else {
      this.video.pause();
    }
    this.classList.toggle("paused", this.video.paused);
  }
}

if (!window.customElements.get("click-video")) {
  window.customElements.define("click-video", ClickVideo);
}

class ProductReviewStars extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    this.addEventListener("click", () => {
      const reviewWidget = document.querySelector("[data-oke-widget]");
      if (reviewWidget) {
        reviewWidget.scrollIntoView({ behavior: "smooth" });
      }
    });
  }
}

if (!window.customElements.get("product-review-stars")) {
  window.customElements.define("product-review-stars", ProductReviewStars);
}

class ProductIconsWithText extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initSwiper();
  }

  initSwiper() {
    this.swiper = new Swiper(this.querySelector(".swiper"), {
      slidesPerView: 2,
      spaceBetween: 12,
      loop: true,
      navigation: {
        nextEl: this.querySelector(".next"),
        prevEl: this.querySelector(".prev"),
      },
      breakpoints: {
        768: {
          slidesPerView: this.getAttribute("data-number-of-icons"),
          loop: false,
          spaceBetween: 24,
        },
      },
    });
  }
}

if (!window.customElements.get("product-icons-with-text")) {
  window.customElements.define("product-icons-with-text", ProductIconsWithText);
}

class WhatsIncludedSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.totalSlides = this.getAttribute("data-total-slides");
    this.initSwiper();
  }

  initSwiper() {
    this.swiper = new Swiper(this, {
      slidesPerView: "auto",
      spaceBetween: 20,
      loop: true,
      centeredSlides: true,
      breakpoints: {
        768: {
          slidesPerView: this.totalSlides,
          loop: false,
          centeredSlides: false,
        },
      },
    });
  }
}

if (!window.customElements.get("whats-included-slider")) {
  window.customElements.define("whats-included-slider", WhatsIncludedSlider);
}

class CartDrawer extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.cartButton = document.querySelectorAll("[data-cart-btn]");
    this.cartButton.forEach((button) =>
      button.addEventListener("click", () => this.openCartDrawer())
    );
    this.closeButton = document.querySelector("[data-close-cart-drawer]");
    this.closeButton.addEventListener("click", () => this.closeCartDrawer());
    this.pageOverlay = document.querySelector(".cart-drawer-overlay");
    this.pageOverlay.addEventListener("click", () => this.closeCartDrawer());
    this.addEventListener("quantity-change", this.onQuantityChange);

    this.querySelectorAll("[data-remove-from-cart]").forEach((button) =>
      button.addEventListener("click", this.onRemoveFromCart.bind(this))
    );

    this.toggleLoading = this.toggleLoading.bind(this);
    this.addEventListener("cart-loading", this.toggleLoading);
    this.toggleLoading(false);

    if (window.location.search.includes("openCart=true")) {
      this.openCartDrawer();
    }
  }

  toggleLoading(show) {
    this.classList.toggle("loading", show);
  }

  openCartDrawer() {
    this.classList.add("open");
  }

  closeCartDrawer() {
    this.classList.remove("open");
  }

  reloadCart(html = null, open = false) {
    if (html) {
      this.updateContent(html);
    } else {
      fetch("?section_id=cart-drawer")
        .then((response) => response.text())
        .then((res) => this.updateContent(res));
    }

    if (open) {
      this.openCartDrawer();
    }
  }

  updateContent(html) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    this.innerHTML = doc.querySelector("cart-drawer").innerHTML;
    this.init();
    this.updateCartCount();
  }

  updateCartCount() {
    const cartCountText = document.querySelector("[data-cart-count-text]");
    const cartCountTarget = document.querySelector("#cart-count-target");
    if (cartCountText && cartCountTarget) {
      cartCountText.textContent = `(${cartCountTarget.textContent})`;
    }
  }

  onQuantityChange(event) {
    const { lineItemId, quantity } = event.detail;

    const updates = {
      [lineItemId]: quantity,
    };

    this.dispatchEvent(
      new CustomEvent("cart-loading", { detail: { show: true }, bubbles: true })
    );

    fetch(`/cart/update.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ updates }),
    }).then(() => this.reloadCart());
  }

  onRemoveFromCart(event) {
    this.dispatchEvent(
      new CustomEvent("cart-loading", { detail: { show: true }, bubbles: true })
    );
    const lineItemKey = event.target.dataset.removeFromCart;
    fetch(`/cart/change.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ id: lineItemKey, quantity: 0 }),
    }).then(() => this.reloadCart());
  }
}

if (!window.customElements.get("cart-drawer")) {
  window.customElements.define("cart-drawer", CartDrawer);
}

class CartProgress extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.currency = this.dataset.currency;
    this.totalPrice = Number(this.dataset.totalPrice);
    this.shippingThresholdInUSD = this.dataset.shippingThreshold;
    this.currencySymbol = this.dataset.currencySymbol;
    if (this.currency === "USD") return;

    const shippingThreshold = Number(
      Currency.convert(
        this.shippingThresholdInUSD,
        "USD",
        this.currency
      ).toFixed(2)
    );

    if (this.querySelector("[data-amount-to-free-shipping]")) {
      this.querySelector("[data-amount-to-free-shipping]").textContent =
        Shopify.formatMoney(
          shippingThreshold - this.totalPrice,
          this.currencySymbol + "{{amount}}"
        );
    }
  }
}

if (!window.customElements.get("cart-progress")) {
  window.customElements.define("cart-progress", CartProgress);
}

class QuantitySelector extends HTMLElement {
  constructor() {
    super();
  }

  init() {
    this.quantityInput = this.querySelector("[data-quantity-input]");
    this.decreaseButton = this.querySelector("[data-decrease-quantity]");
    this.increaseButton = this.querySelector("[data-increase-quantity]");
    this.quantity = parseInt(this.dataset.quantity);
    this.decreaseButton.addEventListener(
      "click",
      this.onDecreaseQuantity.bind(this)
    );
    this.increaseButton.addEventListener(
      "click",
      this.onIncreaseQuantity.bind(this)
    );
  }

  connectedCallback() {
    this.init();
  }

  onDecreaseQuantity() {
    if (this.quantity > 0) {
      this.quantity--;
      this.onQuantityChange();
    }
  }

  onIncreaseQuantity() {
    this.quantity++;
    this.onQuantityChange();
  }

  onQuantityChange() {
    this.quantityInput.textContent = this.quantity;
    this.dispatchEvent(
      new CustomEvent("quantity-change", {
        detail: {
          lineItemId: this.dataset.lineItemId,
          quantity: this.quantity,
        },
        bubbles: true,
      })
    );
  }
}

if (!window.customElements.get("quantity-selector")) {
  window.customElements.define("quantity-selector", QuantitySelector);
}

class AccordionGroup extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.accordions = this.querySelectorAll("details");
    this.bindEvents();
  }

  bindEvents() {
    this.accordions.forEach((accordion) => {
      accordion.addEventListener("click", (e) => {
        const clickedAccordion = e.currentTarget;

        this.accordions.forEach((accordion) => {
          if (
            accordion !== clickedAccordion &&
            accordion.hasAttribute("open")
          ) {
            accordion.removeAttribute("open");
          }
        });
      });
    });
  }
}

if (!window.customElements.get("accordion-group")) {
  window.customElements.define("accordion-group", AccordionGroup);
}

class SearchDrawer extends HTMLElement {
  constructor() {
    super();
    this.debounceTimeout = null;
    this.searchInput = null;
    this.searchResults = null;
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.searchButton = document.querySelectorAll("[data-search-btn]");
    this.searchButton.forEach((button) =>
      button.addEventListener("click", () => this.openDrawer())
    );
    this.searchDrawerClose = this.querySelectorAll("[data-search-drawer-close]");
    this.searchDrawerClose.forEach((button) =>
      button.addEventListener("click", () => this.closeDrawer())
    );
    this.pageOverlay = document.querySelector(".search-drawer-overlay");
    this.pageOverlay.addEventListener("click", () => this.closeDrawer());

    this.searchInput = this.querySelector("[data-search-input]");
    this.searchResults = this.querySelector("[data-search-results]");
    this.form = this.querySelector("[data-search-drawer-form]");

    if (this.searchInput) {
      this.searchInput.addEventListener(
        "input",
        this.handleSearchInput.bind(this)
      );
    }

    this.form.addEventListener("reset", () => {
      this.searchResults.innerHTML = '<div class="contents"></div>';
      this.searchInput.value = "";
    });
  }

  handleSearchInput(event) {
    const query = event.target.value.trim();

    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout);
    }

    if (!query) {
      this.searchResults.innerHTML = '<div class="contents"></div>';
      return;
    }

    this.debounceTimeout = setTimeout(() => {
      this.performSearch(query);
    }, 300);
  }

  async performSearch(query) {
    try {
      const url = `${routes.predictive_search_url}?q=${encodeURIComponent(
        query
      )}&resources[limit_scope]=each&section_id=search-drawer`;

      const response = await fetch(url);
      const data = await response.text();

      const parser = new DOMParser();
      const doc = parser.parseFromString(data, "text/html");
      this.searchResults.innerHTML = doc
        .querySelector("search-drawer")
        .querySelector("[data-search-results]").innerHTML;

      this.initResults();
    } catch (error) {
      console.error("Search error:", error);
      this.searchResults.innerHTML =
        '<div class="contents">Error loading search results.</div>';
    }
  }

  openDrawer() {
    this.classList.add("open");
  }

  closeDrawer() {
    this.classList.remove("open");
  }

  initResults() {
    const triggers = this.querySelectorAll("[data-resource-trigger]");
    const targets = this.querySelectorAll("[data-resource-target]");

    targets.length > 0 && targets[0].classList.remove("hidden");
    triggers.length > 0 && triggers[0].classList.remove("opacity-50");

    triggers.forEach((trigger) => {
      trigger.addEventListener("click", () => {
        targets.forEach((target) =>
          target.classList.toggle(
            "hidden",
            target.dataset.resourceTarget !== trigger.dataset.resourceTrigger
          )
        );
        triggers.forEach((t) => t.classList.toggle("opacity-50", t != trigger));
      });
    });
  }
}

if (!window.customElements.get("search-drawer")) {
  window.customElements.define("search-drawer", SearchDrawer);
}

class WebinarCountdown extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    const timeData = this.getAttribute("js-countdown-data");
    const jsonTimeData = JSON.parse(timeData);
    const starttime = jsonTimeData.starttime;
    const endtime = jsonTimeData.endtime;
    const daysEl = this.querySelector("[data-days]");
    const hoursEl = this.querySelector("[data-hours]");
    const minutesEl = this.querySelector("[data-minutes]");
    const secondsEl = this.querySelector("[data-seconds]");
    const countdownEl = this;

    function addZero(value) {
      if (value < 10) {
        return "0" + value;
      } else {
        return value;
      }
    }

    if (endtime.length > 0) {
      const countDownDate = new Date(endtime).getTime();
      const startDate = new Date(starttime).getTime();
      const checker = setInterval(function () {
        const now = new Date().getTime();

        if (now >= countDownDate) {
          clearInterval(checker);
          daysEl.innerText = "00";
          hoursEl.innerText = "00";
          minutesEl.innerText = "00";
          secondsEl.innerText = "00";
          countdownEl.classList.remove("hidden");
        } else if (now < startDate) {
          countdownEl.classList.add("hidden");
        } else {
          countdownEl.classList.remove("hidden");
          let distance = countDownDate - now;

          if (startDate > now) {
            distance = countDownDate - startDate;
          }

          let days = Math.floor(distance / (1000 * 60 * 60 * 24));
          days = addZero(days);

          let hours = Math.floor(
            (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
          );
          hours = addZero(hours);

          let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          minutes = addZero(minutes);

          let seconds = Math.floor((distance % (1000 * 60)) / 1000);
          seconds = addZero(seconds);

          daysEl.innerText = days;
          hoursEl.innerText = hours;
          minutesEl.innerText = minutes;
          secondsEl.innerText = seconds;

          if (distance < 0) {
            clearInterval(checker);
          }
        }
      }, 1000);
    }
  }
}

if (!window.customElements.get("webinar-countdown")) {
  window.customElements.define("webinar-countdown", WebinarCountdown);
}

class CollectionPage extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    this.collectionUrl = this.dataset.collectionUrl;
    this.collectionGrid = this.querySelector("collection-grid");
    this.addEventListener("sort-change", (event) => {
      this.updateUrl(event.detail.value);
      this.refresh();
    });
  }

  updateUrl(value) {
    const url = new URL(window.location.href);
    url.searchParams.set("sort_by", value);
    window.history.pushState({}, "", url);
  }

  refresh() {
    const currentUrl = new URL(window.location.href);
    const sortBy = currentUrl.searchParams.get("sort_by");
    this.collectionGrid.classList.add("loading");
    fetch(`${this.collectionUrl}?sort_by=${sortBy}`)
      .then((response) => response.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const newCollectionGrid = doc.querySelector("collection-grid");
        this.collectionGrid.innerHTML = newCollectionGrid.innerHTML;
      })
      .finally(() => this.collectionGrid.classList.remove("loading"));
  }
}

if (!window.customElements.get("collection-page")) {
  window.customElements.define("collection-page", CollectionPage);
}

class CollectionSort extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    this.querySelector("[data-open-trigger]").addEventListener("click", () => {
      this.classList.toggle("open");
    });

    this.querySelectorAll("[data-value]").forEach((option) => {
      option.addEventListener("click", () => {
        this.dispatchEvent(
          new CustomEvent("sort-change", {
            detail: {
              value: option.dataset.value,
            },
            bubbles: true,
          })
        );
        this.classList.remove("open");
      });
    });
  }
}

if (!window.customElements.get("collection-sort")) {
  window.customElements.define("collection-sort", CollectionSort);
}
